import { Action } from 'redux';
//Import States
import {
    AppState,
    getInitialMinCostPerSquareFootVersionState,
    MinCostPerSquareFootVersionsState,
    MinCostPerSquareFootVersionState,
} from '@app/redux/states';
// Import Actions
import {
    LoadMinCostsPerSquareFootAction,
    MinCostPerSquareFootVersionAction,
    SelectMinCostPerSquareFootAction,
    UnselectMinCostPerSquareFootAction,
} from '@app/redux/actions';
// Import api models
import {
    MinCostPerSquareFootWithId
} from '@app/models/api';
// State initializers
import {
    initializeMinCostPerSquareFootVersionsState,
} from '@app/redux/reducers/initializers';
// Reducer queries.
import {
    queryMinCostPerSquareFootVersionsState,
} from '@app/redux/reducers/queries';

/**
 * This handles initializing the state.
 * @param state
 */
const initializeState = (state: AppState, action: MinCostPerSquareFootVersionAction): AppState => {
    let newState: AppState = { ...state };
    newState = initializeMinCostPerSquareFootVersionsState(newState);
    let minCostPerSquareFootVersionsState: MinCostPerSquareFootVersionsState = queryMinCostPerSquareFootVersionsState(state);

    if (minCostPerSquareFootVersionsState.minCostPerSquareFootVersionState[action.versionId] === undefined) {
        minCostPerSquareFootVersionsState.minCostPerSquareFootVersionState[action.versionId] = getInitialMinCostPerSquareFootVersionState();
    }
    else {
        minCostPerSquareFootVersionsState.minCostPerSquareFootVersionState[action.versionId] = { ...minCostPerSquareFootVersionsState.minCostPerSquareFootVersionState[action.versionId] };
    }

    return newState;
};

const queryMinCostPerSquareFootVersionState = (state: AppState, action: MinCostPerSquareFootVersionAction): MinCostPerSquareFootVersionState => {
    return queryMinCostPerSquareFootVersionsState(state).minCostPerSquareFootVersionState[action.versionId];
};

//#region Load Min Cost Per Square Foot

const LoadMinCostPerSquareFootReducer = (state: AppState, action: Action): AppState => {
    
    const loadMinCostsPerSquareFootAction: LoadMinCostsPerSquareFootAction = action as LoadMinCostsPerSquareFootAction;
    const minCostsPerSquareFoot: MinCostPerSquareFootWithId[] = loadMinCostsPerSquareFootAction.minCostsPerSquareFoot;

    const newState: AppState = initializeState(state, loadMinCostsPerSquareFootAction);
    const minCostPerSquareFootVersionState: MinCostPerSquareFootVersionState = queryMinCostPerSquareFootVersionState(newState, loadMinCostsPerSquareFootAction);

    minCostPerSquareFootVersionState.minCostsPerSquareFoot = minCostsPerSquareFoot;
    minCostPerSquareFootVersionState.areMinCostsPerSquareFootLoaded = true;

    return newState;
};

//#endregion Load Min Cost Per Square Foot

//#region Select Min Cost Per Square Foot

const SelectMinCostPerSquareFootReducer = (state: AppState, action: Action): AppState => {
    const selectMinCostPerSquareFootAction: SelectMinCostPerSquareFootAction = action as SelectMinCostPerSquareFootAction;
    const minCostPerSquareFootId: number = selectMinCostPerSquareFootAction.minCostPerSquareFootId;

    const newState: AppState = initializeState(state, selectMinCostPerSquareFootAction);
    const minCostPerSquareFootVersionState: MinCostPerSquareFootVersionState = queryMinCostPerSquareFootVersionState(newState, selectMinCostPerSquareFootAction);

    minCostPerSquareFootVersionState.selectedMinCostPerSquareFootId = minCostPerSquareFootId;

    return newState;
};

//#endregion Select Min Cost Per Square Foot

//#region Unselect Min Cost Per Square Foot

const UnselectMinCostPerSquareFootReducer = (state: AppState, action: Action): AppState => {
    const unselectMinCostPerSquareFootAction: UnselectMinCostPerSquareFootAction = action as UnselectMinCostPerSquareFootAction;

    const newState: AppState = initializeState(state, unselectMinCostPerSquareFootAction);
    const minCostPerSquareFootVersionState: MinCostPerSquareFootVersionState = queryMinCostPerSquareFootVersionState(newState, unselectMinCostPerSquareFootAction);

    minCostPerSquareFootVersionState.selectedMinCostPerSquareFootId = undefined;

    return newState;
};

//#endregion Unselect Min Cost Per Square Foot

//#region export reducers

export {
    LoadMinCostPerSquareFootReducer,
    SelectMinCostPerSquareFootReducer,
    UnselectMinCostPerSquareFootReducer,
};

//#endregion export reducers

//#region export queries

export {
    queryMinCostPerSquareFootVersionState
};

//#endregion export queries

//#region export initializer

export { initializeState };

//#endregion export initializer
